<script>
export default {
  name: 'TableRow',
  props: {
    clickRow: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<template>
  <tr
    class="cxm-TableRow"
    @click="clickRow"
  >
    <slot />
  </tr>
</template>

<style lang="scss" scoped>
.cxm-TableRow {
  background-color: var(--track-color-white);
  transition: background-color 0.2s ease;

  :not(thead) > &:hover {
    background-color: var(--track-color-bluegray-10);
  }

  &:last-child td {
    border-bottom-width: var(--track-border-sm)
  }

  &:last-child {
    td:first-child {
      border-bottom-left-radius: var(--track-border-radius-sm)
    }

    td:last-child {
      border-bottom-right-radius:var(--track-border-radius-sm)
    }
  }
}
</style>
